import { useFilters } from 'Admin/Partners/hooks/useFilters';
import { Formik } from 'formik';
import React from 'react';
import { ClearFilterButton } from 'Shared/components/ClearFilterButtons';
import { FormInput } from 'Shared/components/FormInput';

import styles from '../../Admin/Partners/components/PartnerFilters/styles.module.css';

export type MoratoriumsFilterType = {
  name?: string;
  active?: string;
};

const ALLOWED_FILTERS: Array<keyof MoratoriumsFilterType> = ['name', 'active'];

export const MoratoriumsFilters: React.FC<{
  filters: MoratoriumsFilterType;
  onChangeFilters(filters: MoratoriumsFilterType): void;
}> = ({ filters, onChangeFilters }) => {
  const { updateFilters } = useFilters<MoratoriumsFilterType>({
    allowedFilters: ALLOWED_FILTERS,
    onChangeFilters,
  });

  const clearNameFilter = () => {
    onChangeFilters({ ...filters, name: undefined });
  };

  return (
    <Formik enableReinitialize initialValues={filters} onSubmit={updateFilters}>
      {({ handleSubmit, values, handleChange }) => (
        <form
          onSubmit={handleSubmit}
          className={styles.search}
          data-testid="form"
        >
          <FormInput
            name="name"
            className={styles.searchInput}
            value={values.name || ''}
            label="Search name"
            variant="search"
            onChange={handleChange}
            onIconClick={() => {
              handleSubmit();
            }}
          />
          <FormInput
            name="active"
            className={styles.searchInput}
            value={(values.active || 'true') === 'true' ? 'active' : 'inactive'}
            variant="radioButtonGroup"
            options={{
              active: 'Active',
              inactive: 'Inactive',
            }}
            onChange={(value: string) => {
              handleChange({
                target: {
                  name: 'active',
                  value: value === 'active' ? 'true' : 'false',
                },
              });
              setTimeout(() => handleSubmit(), 0);
            }}
          />
          <button
            data-testid="filter-submit"
            type="submit"
            className={styles.submit}
          />
          <div className={styles.clearContainer}>
            <ClearFilterButton
              onClick={clearNameFilter}
              disabled={!filters.name}
              data-testid="clear-filters"
            >
              Clear Search
            </ClearFilterButton>
          </div>
        </form>
      )}
    </Formik>
  );
};
